/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdAttachmentsProps } from './type';
const props: TdAttachmentsProps = {
  /** 是否启用图片预览功能 */
  imageViewer: {
    type: Boolean,
    value: true,
  },
  /** 附件列表 */
  items: {
    type: Array,
    value: [],
    required: true,
  },
  /** 是否显示删除按钮 */
  removable: {
    type: Boolean,
    value: true,
  },
};

export default props;
